import React from 'react';

/**
 * ScopeDot: coloured dot indicating scope (TYPSA / pública / privada).
 * Never the only source of information: always renders title + aria-label.
 * Palette matches /contacts existing scheme.
 */
const SCOPE_STYLE = {
  typsa:   { color: 'bg-red-600',    label: 'TYPSA' },
  publica: { color: 'bg-green-500',  label: 'Empresa pública' },
  privada: { color: 'bg-purple-500', label: 'Empresa privada' },
};

export const ScopeDot = ({ scope, className = '' }) => {
  const style = SCOPE_STYLE[scope];
  if (!style) return null; // Omit when unknown — never fake grey
  return (
    <span
      className={`inline-block w-2 h-2 rounded-full shrink-0 mr-2 ${style.color} ${className}`}
      title={style.label}
      aria-label={style.label}
      data-testid={`scope-dot-${scope}`}
    />
  );
};

export default ScopeDot;
